"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeResponseError = exports.BeeArgumentError = exports.BeeError = void 0;
class BeeError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.BeeError = BeeError;
class BeeArgumentError extends BeeError {
    constructor(message, value) {
        super(message);
        this.value = value;
    }
}
exports.BeeArgumentError = BeeArgumentError;
class BeeResponseError extends BeeError {
    constructor(method, url, message, responseBody, status, statusText) {
        super(message);
        this.method = method;
        this.url = url;
        this.responseBody = responseBody;
        this.status = status;
        this.statusText = statusText;
    }
}
exports.BeeResponseError = BeeResponseError;
